export var SeverityFilterValue;
(function (SeverityFilterValue) {
    SeverityFilterValue["SEVERITY_FILTER_VALUE_HIGH"] = "HIGH";
    SeverityFilterValue["SEVERITY_FILTER_VALUE_MEDIUM"] = "MEDIUM";
    SeverityFilterValue["SEVERITY_FILTER_VALUE_LOW"] = "LOW";
    SeverityFilterValue["SEVERITY_FILTER_VALUE_MUTED"] = "MUTED";
})(SeverityFilterValue || (SeverityFilterValue = {}));
